const extractDomainFromEmail = email => {
  const atIndex = email?.indexOf('@');
  if (atIndex !== -1) {
    const domain = email?.substring(atIndex + 1);
    return domain;
  }
  return '';
};
export default extractDomainFromEmail;
